export { default as AlignmentMatrixControl } from './AlignmentMatrixControl';